/**
 * description: 选择音频的弹出框
 * created by liu jinming
 * created on 2017.09.28
 */
"use strict";
angular.module('trsGetHistoryVideoModule', [])
    .controller('trsGetHistoryVideoCtrl', ["$scope", "trsHttpService", "modalDialog", "$sce", "videoId", "$modalInstance",
        function($scope, trsHttpService, modalDialog, $sce, videoId, $modalInstance) {
            initData();

            function initData() {
                $scope.status = {
                    historyList:[],
                    isShow: false,
                    videoId: videoId
                };
                var params = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getVideoHistory',
                    videoId: videoId,
                    resourceType: 'video/mp4'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.data == 'null') {
                        $scope.status.isShow = false;
                    } else if (data.data.length>0) {
                        $scope.status.isShow = true;
                    }
                    $scope.status.historyList = data.data;
                });
            }
            $scope.close = function() {
                $modalInstance.close("cancel");
            };
            /**根据videoId获取url*/
            $scope.getHistoryVideo = function(item) {
                var zjVParams = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getMediaFrame',
                    mediaId: item,
                    resourceType: 'video/mp4'
                };
                $scope.status.videoId = item;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), zjVParams, 'post').then(function(data) {
                    if (data.msg == "视频不存在") {
                        modalDialog.alertType('', '视频资源无法找到请确认视频信息', 'error', true);
                    } else {
                        var url = data.data.mediaFrameUrl;
                        url = url.replace(/\"/g, '');
                        var obj = { 'URL': url, 'videoId': item };
                        $modalInstance.close(obj);
                    }
                });
            };
        }
    ]);